import { DemoGameLiveConnection } from './gameLiveConnectionsStrategy/DemoGameLiveConnection';
import { configStore } from '../store/configStore';
import { PlayingGameMode } from '../../enums/PlayingGameMode';
import { RealGameLiveConnection } from './gameLiveConnectionsStrategy/RealGameLiveConnection';
import { popupStore } from '@pascal/pascal-core/shared/core/store';

let timeOutId;

class GameLiveConnection {
  constructor(instances) {
    this.instances = instances;
  }

  get instance() {
    return this.instances[configStore.mode];
  }

  init() {
    return this.instance.init();
  }

  setConnectionListeners() {
    return this.instance.setConnectionListeners();
  }

  sendGetInitialState() {
    return this.instance.sendGetInitialState();
  }

  sendClose() {
    return this.instance.stop();
  }

  sendDoSpin() {
    return this.instance.sendDoSpin();
  }

  sendResultReport() {
    return this.instance.sendResultReport();
  }

  sendCashOut() {
    return this.instance.sendCashOut();
  }

  sendPreBonusReportState() {
    return this.instance.sendPreBonusReportState();
  }

  sendBonusReportStateResult(type) {
    return this.instance.sendBonusReportStateResult(type);
  }

  socketRecursiveReconnecting() {
    try {
      this.instance.stop()
        .then(() => {
          this.init().then(() => {
            this.setConnectionListeners();
            this.sendGetInitialState().then(() => {
              popupStore.onConnectionError(false);
              popupStore.toggleReconnect(false);
            });
          });
          clearTimeout(timeOutId);
        })
        .catch(() => {
          timeOutId = setTimeout(() => {
            this.socketRecursiveReconnecting();
          }, 4000);
        });
    } catch (err) {
      popupStore.onConnectionError(true);
    }
  }
}

export const gameLiveConnection = new GameLiveConnection({
  [PlayingGameMode.Real]: new RealGameLiveConnection(),
  [PlayingGameMode.Demo]: new DemoGameLiveConnection(),
});
